/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B020012 セット構成品入力（売上）
 */
import { Column } from "@material-table/core";
import { Box } from "@mui/system";
import Big from "big.js";
import {
  B000111meisaikoseiBiko,
  B000190SokoNmSokoshubetsuKbn,
  B010012WhTanka,
  B020012HandleChangeShohinCd,
  B020012Shohin,
  B020010Kanosu,
  B020012ShohinZaiko,
} from "clients/rest";
import {
  msgState,
  SCancelButton,
  SEntryTab,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientError } from "messages";
import { getSCode, HyoziKazeiKbn } from "messages/codes";
import { labels } from "messages/labels";
import { B000111, B000220 } from "pages";
import { B000190 } from "pages/b000/B000190";
import { B000200 } from "pages/b000/B000200";
import { createRef, useContext, useEffect, useState } from "react";
import { FormProvider, useForm, UseFormReturn } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  digit,
  getHitsuyosu,
  getJuchuKin,
  getJuchutanka,
  mapIds,
} from "services";
import {
  editKbn,
  setshohinKbn,
  shohinShokuchiKbn,
  shohinshubetsuKbn,
  sokoshubetsuKbn,
  tankaKbn,
  tenyuryokujodaiKbn,
  tenyuryokuuriKbn,
  uriagesakuseiKbn,
  zaikokanriKbn,
} from "services/codes";
import { focusState, SDialogContext, useFocus } from "states";

// 詳細設計書 テーブル meisaikoseiBikoCd	明細構成備考コードとあるが非表示か？
// 詳細設計書 明細入力部・テーブル setshohinKbnの記載が無い 処理詳細 4の「5setshohinKbn(セット商品区分)をチェックする。」で使うので必要
// 在庫照会実装後ダイアログ設定する
// 課題 {...register()}の設定した数字通りにフォーカスが動かない

// 呼び出し時のプロパティ
export type B020012Props = Partial<{
  editKbn: string;
  fields: Fields;
  data: Data[];
  meiMethods: UseFormReturn;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  setshohinCd: string;
  setshohinNm: string;
  urisu: string;
  uriageSakuseiKbn: number;
  getsujiYmd: string;
  uchiwakeKbn: string;
  ikkatsukakeritsu: string;
  setjodaitanka: string;
  seturitanka: string;
  zeiRitsu: string;
  uriYmd: string | null;
  tokuiCd: string;
  tokuishitenCd: string;
  zeimarumeKbn: number;
  kinmarumeKbn: number;
  tankamarumeKbn: string;
  tankahasuichi: string;
  zeiKbn: string;
  tankaKakeritsu: string;
  jodaihyojiKbn: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  setshohinCd: "",
  setshohinNm: "",
  urisu: "",
  uriageSakuseiKbn: undefined,
  getsujiYmd: "",
  uchiwakeKbn: "",
  ikkatsukakeritsu: "",
  setjodaitanka: "",
  seturitanka: "",
  zeiRitsu: "",
  uriYmd: "",
  tokuiCd: "",
  tokuishitenCd: "",
  zeimarumeKbn: undefined,
  kinmarumeKbn: undefined,
  tankamarumeKbn: "",
  tankahasuichi: "",
  zeiKbn: "",
  tankaKakeritsu: "",
  jodaihyojiKbn: "",
};

type Data = Partial<{
  uridenpyoNo: string;
  urigyoNo: number;
  urikoseigyoNo: number;
  juchudenpyoNo: string;
  juchugyoNo: string;
  juchukoseigyoNo: string;
  shohinCd: string;
  shohinCdBefore: string;
  janCd: string;
  aiteCd: string;
  shohinNm: string;
  vol: string;
  sotosunView: string;
  uchisunView: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  koseisu: string;
  hitsuyosu: string;
  hitsuyosuBefore: string;
  kanosu: string;
  jodaitanka: string;
  uritanka: string;
  kakeritsu: string;
  uriKin: string;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  kazeiKbn: number;
  tenyuryokujodaiKbn: number;
  tenyuryokuuriKbn: number;
  basejodaitanka: string;
  baseuritanka: string;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  shokuchiKbn: number;
  whtankaCd: string;
  setshohinKbn: number;
  zaikokanriKbn: number;
  crtDate: string;
  crtshainCd: string;
}>;

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "uridenpyoNo", title: "売上伝票番号", hidden: true },
  { field: "urigyoNo", title: "売上行番号", hidden: true },
  { field: "urikoseigyoNo", title: "行", width: "4rem" },
  { field: "juchudenpyoNo", title: "受注伝票番号", hidden: true },
  { field: "juchugyoNo", title: "受注行番号", hidden: true },
  { field: "juchukoseigyoNo", title: "受注構成行番号", hidden: true },
  { field: "shohinCd", title: "商品コード", width: "7rem" },
  { field: "shohinCdBefore", title: "商品コード(変更前)", hidden: true },
  { field: "aiteCd", title: "相手コード", width: "5rem" },
  { field: "shohinNm", title: "商品名", width: "13rem" },
  { field: "vol", title: "VOL", width: "4rem" },
  {
    field: "sotosunView",
    title: "WH(外)",
    width: "7rem",
    render: (data) => {
      if (data.sotosunW && Number(data.sotosunW) > 0) {
        return data.sotosunW + " x " + data.sotosunH;
      }
    },
  },
  {
    field: "uchisunView",
    title: "WH(内)",
    width: "7rem",
    render: (data) => {
      if (data.uchisunW && Number(data.uchisunW) > 0) {
        return data.uchisunW + " x " + data.uchisunH;
      }
    },
  },
  { field: "sotosunW", title: "外幅", hidden: true },
  { field: "sotosunH", title: "外高さ", hidden: true },
  { field: "uchisunW", title: "内幅", hidden: true },
  { field: "uchisunH", title: "内高さ", hidden: true },
  {
    field: "koseisu",
    title: "構成数　",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.koseisu),
  },
  {
    field: "hitsuyosu",
    title: "必要数　",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.hitsuyosu),
  },
  { field: "hitsuyosuBefore", title: "必要数(変更前)", hidden: true },
  {
    field: "kanosu",
    title: "可能数　",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.kanosu),
  },
  {
    field: "jodaitanka",
    title: "上代　",
    width: "5rem",
    align: "right",
    render: (data) => {
      let backgroundColor = "inherit";
      if (data.tenyuryokujodaiKbn === tenyuryokujodaiKbn.exists) {
        backgroundColor = "#FFFF00";
      }
      return <Box sx={{ backgroundColor }}>{digit(data.jodaitanka)}</Box>;
    },
  },
  {
    field: "uritanka",
    title: "下代　",
    width: "5rem",
    align: "right",
    render: (data) => {
      let backgroundColor = "inherit";
      if (data.tenyuryokuuriKbn === tenyuryokuuriKbn.exists) {
        backgroundColor = "#FFFF00";
      }
      return <Box sx={{ backgroundColor }}>{digit(data.uritanka)}</Box>;
    },
  },
  { field: "kakeritsu", title: "掛率　", width: "6rem", align: "right" },
  {
    field: "uritanka",
    title: "金額　",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.uritanka),
  },
  { field: "sokoCd", title: "倉庫", width: "4rem" },
  { field: "sokoNm", title: "", width: "6rem" },
  { field: "sokoshubetsuKbn", title: "", hidden: true },
  { field: "meisaikoseiBiko", title: "構成明細備考", width: "12rem" },
  { field: "meisaikoseiBikoCd", title: "", hidden: true },
  {
    field: "kazeiKbnView",
    title: "税",
    width: "4rem",
    render: (data) =>
      getSCode(HyoziKazeiKbn, data.kazeiKbn?.toString() ?? "")?.label,
  },
  { field: "kazeiKbn", title: "税", hidden: true },
  { field: "janCd", title: "JAN コード", width: "5rem", hidden: true },
  { field: "tenyuryokujodaiKbn", hidden: true },
  { field: "tenyuryokuuriKbn", hidden: true },
  { field: "basejodaitanka", hidden: true },
  { field: "baseuritanka", hidden: true },
  { field: "shohinshubetsuKbn", hidden: true },
  { field: "tankaKbn", hidden: true },
  { field: "shokuchiKbn", hidden: true },
  { field: "whtankaCd", hidden: true },
  { field: "setshohinKbn", hidden: true },
  { field: "zaikokanriKbn", hidden: true },
  { field: "crtDate", hidden: true },
  { field: "crtshainCd", hidden: true },
];

//明細入力部
type MeiFields = Partial<{
  meiTab: boolean;
  uridenpyoNo: string;
  urigyoNo: number;
  urikoseigyoNo: number;
  juchudenpyoNo: string;
  juchugyoNo: string;
  juchukoseigyoNo: string;
  shohinCd: string;
  shohinCdBefore: string;
  janCd: string;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  shohinNm: string;
  aiteCd: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  hitsuyosu: string;
  hitsuyosuBefore: string;
  koseisu: string;
  vol: string;
  kanosu: string;
  jodaitanka: string;
  uritanka: string;
  kakeritsu: string;
  uriKin: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBikoBefore: string;
  meisaikoseiBiko: string;
  kazeiKbn: number;
  meisaicreateBtn: string;
  meisaiupdateBtn: string;
  meisaideleteBtn: string;
  tenyuryokujodaiKbn: number;
  tenyuryokuuriKbn: number;
  basejodaitanka: string;
  baseuritanka: string;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  shokuchiKbn: number;
  jodaihyojiKbn: string;
  zeimarumeKbn: string;
  whtankaCd: string;
  setshohinKbn: number;
  zaikokanriKbn: number;
  crtDate: string;
  crtshainCd: string;
  dirtyFields: {
    shohinCd: string;
    sokoCd: string;
    sotosunW: string;
    sotosunH: string;
    koseisu: string;
    jodaitanka: string;
    uritanka: string;
    kakeritsu: string;
  };
}>;

const defaultMeiFields: MeiFields = {
  meiTab: true,
  uridenpyoNo: "",
  urigyoNo: undefined,
  urikoseigyoNo: undefined,
  juchudenpyoNo: "",
  juchugyoNo: "",
  juchukoseigyoNo: "",
  shohinCd: "",
  shohinCdBefore: "",
  janCd: "",
  sokoCd: "",
  sokoNm: "",
  sokoshubetsuKbn: "",
  shohinNm: "",
  aiteCd: "",
  sotosunW: "",
  sotosunH: "",
  uchisunW: "",
  uchisunH: "",
  hitsuyosu: "",
  hitsuyosuBefore: "",
  koseisu: "",
  vol: "",
  kanosu: "",
  jodaitanka: "",
  uritanka: "",
  kakeritsu: "",
  uriKin: "",
  meisaikoseiBikoCd: "",
  meisaikoseiBikoBefore: "",
  meisaikoseiBiko: "",
  kazeiKbn: undefined,
  meisaicreateBtn: "",
  meisaiupdateBtn: "",
  meisaideleteBtn: "",
  tenyuryokujodaiKbn: undefined,
  tenyuryokuuriKbn: undefined,
  basejodaitanka: "",
  baseuritanka: "",
  shohinshubetsuKbn: undefined,
  tankaKbn: undefined,
  shokuchiKbn: undefined,
  jodaihyojiKbn: "",
  zeimarumeKbn: "",
  whtankaCd: "",
  setshohinKbn: undefined,
  zaikokanriKbn: undefined,
  crtDate: "",
  crtshainCd: "",
  dirtyFields: {
    shohinCd: "",
    sokoCd: "",
    sotosunW: "",
    sotosunH: "",
    koseisu: "",
    jodaitanka: "",
    uritanka: "",
    kakeritsu: "",
  },
};

// 固定値
const focusId = "B020012";
// 内訳区分(通常)
const uchiwakeKbnTujo = [0, 1, 2, 3, 4, 5];
// 内訳区分(返品)
const uchiwakeKbnHenpin = [10, 11, 12, 13, 14, 15];
const jodaitankaMaxLength = 9;
const uritankaMaxLength = 9;
const urisuThreshold = 0;
const whMin = 1;
const butsuriSoko = 901;

export const B020012 = (props: B020012Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};
const Page = (props: B020012Props) => {
  // 初期設定
  // テーブル管理
  const tableRef = createRef();
  const [rows, setRows] = useState<Data[]>([]);
  const [rowCount, setRowCount] = useState(0);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // ダイアログで処理を行う関数
  const handleSubmit = useContext(SDialogContext);

  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  const meiMethods = useForm<MeiFields>({
    mode: "onBlur",
    defaultValues: defaultMeiFields,
  });

  // dirtyFields初期化
  const resetMeiDirtyFields = () => {
    const fields = meiMethods.getValues();
    meiMethods.setValue("dirtyFields.shohinCd", fields.shohinCd ?? "");
    meiMethods.setValue("dirtyFields.sokoCd", fields.sokoCd ?? "");
    meiMethods.setValue("dirtyFields.sotosunW", fields.sotosunW ?? "");
    meiMethods.setValue("dirtyFields.sotosunH", fields.sotosunH ?? "");
    meiMethods.setValue("dirtyFields.koseisu", fields.koseisu ?? "");
    meiMethods.setValue("dirtyFields.jodaitanka", fields.jodaitanka ?? "");
    meiMethods.setValue("dirtyFields.uritanka", fields.uritanka ?? "");
    meiMethods.setValue("dirtyFields.kakeritsu", fields.kakeritsu ?? "");
  };

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();

  // 参照モード設定
  const [isReference, setIsReference] = useState(true);
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 再レンダリング用フラグ
  const [reRender, setReRender] = useState(false);
  const reRendering = () => {
    resetMeiDirtyFields();
    setReRender(!reRender);
  };

  // ベース上代単価、上代単価が一致するかどうか(手入力上代区分)
  const isTenyuryokujodaiKbn = () =>
    Number(meiMethods.getValues().basejodaitanka) ===
    Number(meiMethods.getValues().jodaitanka);
  // ベース下代単価、下代単価が一致するかどうか(手入力受注区分)
  const isTenyuryokuuriKbn = () =>
    Number(meiMethods.getValues().baseuritanka) ===
    Number(meiMethods.getValues().uritanka);
  // 商品.諸口区分が「1:諸口」かどうか
  const isShohinShokuchiKbn = () =>
    meiMethods.getValues().shokuchiKbn === shohinShokuchiKbn.shokuchi;
  // 明細入力部の金額の入力可否(構成数が入力済、かつ下代が入力済の場合、入力不可)
  const isKingakuDisabled = () =>
    meiMethods.getValues().koseisu !== "" &&
    meiMethods.getValues().uritanka !== "";
  // 商品.商品種別区分が「4:受注生産品」かどうか
  const isMeiJuchuSeisanhin = () =>
    meiMethods.getValues().shohinshubetsuKbn === shohinshubetsuKbn.madeToOrder;
  // 商品.セット商品区分が「1:セット品」かどうか
  const isSetshohinKbn = () =>
    meiMethods.getValues().setshohinKbn === setshohinKbn.set;

  // 初期表示イベント
  useEffect(() => {
    focus(1);
    // 編集区分の設定
    switch (props.editKbn) {
      case editKbn.register:
        setIsReference(false);
        break;
      case editKbn.update:
        setIsReference(false);
        break;
      case editKbn.reference:
        setIsReference(true);
        break;
      default:
        setIsReference(true);
        break;
    }

    // 入力プロパティの反映
    methods.setValue("setshohinCd", props.fields?.setshohinCd);
    methods.setValue("setshohinNm", props.fields?.setshohinNm);
    methods.setValue("urisu", props.fields?.urisu);
    methods.setValue("zeiRitsu", props.fields?.zeiRitsu);
    methods.setValue("uriYmd", props.fields?.uriYmd);
    methods.setValue("tokuiCd", props.fields?.tokuiCd);
    methods.setValue("tokuishitenCd", props.fields?.tokuishitenCd);
    methods.setValue("uriageSakuseiKbn", props.fields?.uriageSakuseiKbn);
    methods.setValue("getsujiYmd", props.fields?.getsujiYmd);
    methods.setValue("zeimarumeKbn", props.fields?.zeimarumeKbn);
    methods.setValue("kinmarumeKbn", props.fields?.kinmarumeKbn);
    methods.setValue("tankamarumeKbn", props.fields?.tankamarumeKbn);
    methods.setValue("tankahasuichi", props.fields?.tankahasuichi);
    methods.setValue("zeiKbn", props.fields?.zeiKbn);
    methods.setValue("tankaKakeritsu", props.fields?.tankaKakeritsu);
    methods.setValue("uchiwakeKbn", props.fields?.uchiwakeKbn);
    methods.setValue("jodaihyojiKbn", props.fields?.jodaihyojiKbn);
    // ディープコピーするため、mapとスプレッド構文で設定
    setRows(props.data ? props.data.map((list) => ({ ...list })) : []);
    reRendering();
  }, []);

  // 明細変更
  useEffect(() => {
    //合計金額算出
    handleGokeiCalculating();
    reRendering();
  }, [rows]);

  const b020012Props: B020012Props = {
    editKbn: editKbn.update,
    fields: {},
    data: [],
    meiMethods: meiMethods,
  };
  // 登録ボタンクリックイベント
  const handleClickCreateButton = () => {
    const fields = methods.getValues();
    b020012Props.fields = {
      urisu: fields.urisu,
      setjodaitanka: fields.setjodaitanka,
      seturitanka: fields.seturitanka,
    };
    b020012Props.data = rows?.map((value) => ({
      uridenpyoNo: value.uridenpyoNo,
      urigyoNo: value.urigyoNo,
      urikoseigyoNo: value.urikoseigyoNo,
      juchudenpyoNo: value.juchudenpyoNo,
      juchugyoNo: value.juchugyoNo,
      juchukoseigyoNo: value.juchukoseigyoNo,
      shohinCd: value.shohinCd,
      shohinCdBefore: value.shohinCdBefore,
      janCd: value.janCd,
      aiteCd: value.aiteCd,
      shohinNm: value.shohinNm,
      vol: value.vol,
      sotosunW: value.sotosunW,
      sotosunH: value.sotosunH,
      uchisunW: value.uchisunW,
      uchisunH: value.uchisunH,
      koseisu: value.koseisu,
      hitsuyosu: value.hitsuyosu,
      hitsuyosuBefore: value.hitsuyosuBefore,
      kanosu: value.kanosu,
      jodaitanka: value.jodaitanka,
      uritanka: value.uritanka,
      kakeritsu: value.kakeritsu,
      uriKin: value.uriKin,
      sokoCd: value.sokoCd,
      sokoNm: value.sokoNm,
      sokoshubetsuKbn: value.sokoshubetsuKbn,
      meisaikoseiBikoCd: value.meisaikoseiBikoCd,
      meisaikoseiBiko: value.meisaikoseiBiko,
      kazeiKbn: value.kazeiKbn,
      tenyuryokujodaiKbn: value.tenyuryokujodaiKbn,
      tenyuryokuuriKbn: value.tenyuryokuuriKbn,
      basejodaitanka: value.jodaitanka,
      baseuritanka: value.uritanka,
      shohinshubetsuKbn: value.shohinshubetsuKbn,
      tankaKbn: value.tankaKbn,
      shokuchiKbn: value.shokuchiKbn,
      whtankaCd: value.whtankaCd,
      setshohinKbn: value.setshohinKbn,
      crtDate: value.crtDate,
      crtshainCd: value.crtshainCd,
    }));

    // 変更されたデータ内容を受注入力画面へ
    handleSubmit(b020012Props);
  };

  // 一括掛率の計算
  const handleClickCalculateButton = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();

    // 一括掛率が未入力の場合
    if (fields.ikkatsukakeritsu === "") {
      // 何もしない
      return;
    }
    // 明細が設定されていない場合
    if (rows.length === 0) {
      // 何もしない
      return;
    }

    // 再計算を行う
    const newRows = rows.map((meiRow: Data) => {
      // 掛率の再設定
      meiRow.kakeritsu = fields.ikkatsukakeritsu;
      // 下代単価
      meiRow.uritanka = getJuchutanka(
        methods,
        meiRow.jodaitanka!,
        meiRow.kakeritsu!
      );
      // 売上金額
      meiRow.uriKin = getJuchuKin(
        meiRow.uritanka,
        meiRow.hitsuyosu!,
        fields.kinmarumeKbn!
      );
      return meiRow;
    });

    setRows(newRows);
  };

  // 売上数の変更
  const handleChangeUrisu = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();

    // 構成数が未入力の場合、必要数、受注金額は再計算しない
    if (meiFields.koseisu !== "") {
      // 明細入力部の変更
      // 必要数を設定
      meiMethods.setValue(
        "hitsuyosu",
        getHitsuyosu(meiFields.koseisu!, fields.urisu!)
      );

      // 受注金額
      handleCalcUriKin();
      reRendering();
    }

    // 明細が設定されていない場合、明細の再計算は行わない
    if (rows.length !== 0) {
      // 再計算を行う
      const newRows = rows.map((meiRow: Data) => {
        // 必要数
        meiRow.hitsuyosu = getHitsuyosu(meiRow.koseisu!, fields.urisu!);
        // 受注金額
        meiRow.uriKin = getJuchuKin(
          meiRow.uritanka!,
          meiRow.hitsuyosu!,
          fields.kinmarumeKbn!
        );
        return meiRow;
      });

      setRows(newRows);
    }
  };

  // 下代、売上金額設定
  const handleCalcUritankaUriKin = () => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();

    if (
      meiFields.kakeritsu === meiFields.dirtyFields?.kakeritsu &&
      meiFields.jodaitanka === meiFields.dirtyFields?.jodaitanka
    ) {
      return;
    }

    // 上代単価、掛率が未入力の場合
    if (meiFields.jodaitanka === "") {
      return;
    }
    if (meiFields.kakeritsu === "") {
      return;
    }

    // 手入力受注区分が「1:有り」の場合
    if (!isTenyuryokuuriKbn()) {
      return;
    }

    // 下代単価取得
    const uritanka: string = getJuchutanka(
      methods,
      meiFields.jodaitanka!,
      meiFields.kakeritsu!
    );
    // 下代単価
    meiMethods.setValue("uritanka", uritanka);
    // ベース下代単価
    meiMethods.setValue("baseuritanka", uritanka);

    // 売上金額
    handleCalcUriKin();
    reRendering();
  };

  // 構成数変更
  const handleChangeKoseisu = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();

    // 受注数が入力されている場合
    if (fields.urisu !== "") {
      // 必要数を設定
      meiMethods.setValue(
        "hitsuyosu",
        getHitsuyosu(meiFields.koseisu!, fields.urisu!)
      );
    }

    // 売上金額
    handleCalcUriKin();
    reRendering();
  };

  // 下代入力時設定
  const handleCalcUriKinFromUritanka = () => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();
    if (meiFields.uritanka === meiFields.dirtyFields?.uritanka) return;
    handleCalcUriKin();
    reRendering();
  };

  // 売上金額設定
  const handleCalcUriKin = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();
    // 売上金額
    meiMethods.setValue(
      "uriKin",
      getJuchuKin(
        meiFields.uritanka!,
        meiFields.hitsuyosu!,
        fields.kinmarumeKbn!
      )
    );
  };

  // 商品コード変更
  const handleChangeShohinCd = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (meiFields.shohinCd === meiFields.dirtyFields?.shohinCd) return;
      await B020012HandleChangeShohinCd(methods, meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // 倉庫コード変更
  const handleChangeSokoCd = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (meiFields.sokoCd === meiFields.dirtyFields?.sokoCd) return;
      // 倉庫名表示
      await B000190SokoNmSokoshubetsuKbn(meiMethods, navigate, setMsg);
      // 引当可能数取得処理
      await B020010Kanosu(methods, meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // WH単価変更
  const handleChangeWhTanka = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (
        meiFields.sotosunW === meiFields.dirtyFields?.sotosunW &&
        meiFields.sotosunH === meiFields.dirtyFields?.sotosunH
      ) {
        return;
      }
      await B010012WhTanka(methods, meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // タブ切替
  const handleChangeMeiTab = () => {
    if (!meiMethods.watch("meiTab")) return;
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });
    meiMethods.setValue("meiTab", true);
    reRendering();
  };

  // 明細登録
  const handleClickCreateMeiButton = () => {
    // 独自チェック
    if (invalidated()) return;

    // フィールドチェック
    meiMethods.handleSubmit(
      () => {
        // 明細に設定するデータを取得
        const urikoseigyoNo: number = rows.length + 1;
        const data: Data = handleDataMapping(urikoseigyoNo);

        // 明細を設定
        setRows([...rows, data]);
        setRowCount(urikoseigyoNo);

        // 行選択の解除
        setRowData(undefined);

        // 明細クリア
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
          janCd: "",
        });

        // 明細入力部を新規登録に変更する(明示的にtrueに設定しないと削除、更新ボタンが表示される)
        meiMethods.setValue("meiTab", true);

        focus(5);
        reRendering();
      },
      () => {
        focus(5);
        reRendering();
      }
    )();
  };

  // 明細更新
  const handleClickUpdateMeiButton = () => {
    // 独自チェック
    if (invalidated()) return;

    // フィールドチェック
    meiMethods.handleSubmit(
      () => {
        const urikoseigyoNo: number = rowData!.urikoseigyoNo!;
        // 明細に設定するデータを取得
        const data: Data = handleDataMapping(urikoseigyoNo);
        // 明細を設定
        rows[urikoseigyoNo - 1] = data;
        setRows([...rows]);

        // 行選択の解除
        setRowData(undefined);

        // 明細クリア
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
          janCd: "",
        });

        // 明細入力部を新規登録に変更する
        meiMethods.setValue("meiTab", true);
        focus(5);
        reRendering();
      },
      () => {
        focus(5);
        reRendering();
      }
    )();
  };

  // 独自チェック
  const invalidated = (): boolean => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();
    // 行番号
    const urikoseigyoNo: number = rowData?.urikoseigyoNo ?? rows.length + 1;

    // 内訳区分の選択値が「通常」かどうか
    const isTujo: boolean = uchiwakeKbnTujo.some(
      (uchiwakeKbn) => uchiwakeKbn === Number(fields.uchiwakeKbn)
    );
    // 内訳区分の選択値が「返品」かどうか
    const isHenpin: boolean = uchiwakeKbnHenpin.some(
      (uchiwakeKbn) => uchiwakeKbn === Number(fields.uchiwakeKbn)
    );

    // sokoCd チェック
    // sokoCd が「901」の場合物理倉庫なのでエラー
    if (Number(meiFields.sokoCd) === butsuriSoko) {
      setMsg(getClientError("B020012_018"));
      return true;
    }

    // 売上数が未入力の場合
    if (fields.urisu === "") {
      setMsg(getClientError("B020012_016"));
      return true;
    }

    // ☆入力値チェック
    // 外寸の入力値チェック
    if (meiFields.sotosunH || meiFields.sotosunW) {
      // 外寸が片方だけ入力されている場合エラー
      if (!meiFields.sotosunW) {
        setMsg(getClientError("B020012_001"));
        return true;
      }
      if (!meiFields.sotosunH) {
        setMsg(getClientError("B020012_002"));
        return true;
      }
    }
    // 内寸の入力値チェック
    if (meiFields.uchisunH || meiFields.uchisunW) {
      // 内寸が片方だけ入力されている場合エラー
      if (!meiFields.uchisunW) {
        setMsg(getClientError("B020012_005"));
        return true;
      }
      if (!meiFields.uchisunH) {
        setMsg(getClientError("B020012_006"));
        return true;
      }
    }

    // 商品種別区分が「4」(受注生産)ではない場合
    if (meiFields.shohinshubetsuKbn !== shohinshubetsuKbn.madeToOrder) {
      // sokoCd が空の場合エラー
      if (meiFields.sokoCd === "") {
        setMsg(getClientError("B020012_009"));
        return true;
      }
    }

    // 上代合計・下代合計の金額が9桁より大きい場合エラー
    // 上代合計(現在編集中の行を除いた合計値を取得)
    const jodaitankaGokei: string = rows
      .filter(function (source: Data) {
        return source.urikoseigyoNo !== urikoseigyoNo;
      })
      .reduce((acc: Big, row: Data): Big => {
        return acc.plus(new Big(row.jodaitanka ? row.jodaitanka : "0"));
      }, new Big("0"))
      .plus(new Big(meiFields.jodaitanka ? meiFields.jodaitanka : "0"))
      .toString();
    // 売上金額が9桁より大きい場合
    if (jodaitankaGokei.length > jodaitankaMaxLength) {
      setMsg(getClientError("B020012_010"));
      return true;
    }

    // 下代合計(現在編集中の行を除いた合計値を取得)
    const uritankaGokei: string = rows
      .filter(function (source: Data) {
        return source.urikoseigyoNo !== urikoseigyoNo;
      })
      .reduce((acc: Big, row: Data): Big => {
        return acc.plus(new Big(row.uritanka ? row.uritanka : "0"));
      }, new Big("0"))
      .plus(new Big(meiFields.uritanka ? meiFields.uritanka : "0"))
      .toString();
    // 売上金額が9桁より大きい場合
    if (uritankaGokei.length > uritankaMaxLength) {
      setMsg(getClientError("B020012_011"));
      return true;
    }

    // 売上作成区分 が 新規作成(1)
    if (fields.uriageSakuseiKbn === uriagesakuseiKbn.new) {
      // 内訳区分が通常(0~5)
      if (isTujo) {
        // 倉庫種別が「4」(返品倉庫)、倉庫種別が「5」(その他倉庫)ではない場合エラー
        if (
          Number(meiFields.sokoshubetsuKbn) !== sokoshubetsuKbn.henpinSoko &&
          Number(meiFields.sokoshubetsuKbn) !== sokoshubetsuKbn.othersSoko
        ) {
          setMsg(getClientError("B020012_013"));
          return true;
        }
      }

      // 内訳区分が返品(10~15)
      // 倉庫種別が「4」(返品倉庫)ではない場合エラー
      if (
        isHenpin &&
        Number(meiFields.sokoshubetsuKbn) !== sokoshubetsuKbn.henpinSoko
      ) {
        setMsg(getClientError("B020012_014"));
        return true;
      }
    }

    // ☆可能数チェック
    // 売上作成区分.受注確定の場合は可能数チェックしない
    if (fields.uriageSakuseiKbn !== uriagesakuseiKbn.juchuKakutei) {
      // uchiwakeKbn(内訳区分)と shohinshubetsuKbn(商品種別区分)をチェックする。
      // 在庫管理区分が1「する」の場合
      if (meiFields.zaikokanriKbn?.toString() === zaikokanriKbn.on) {
        // 内訳区分が通常(0~5)
        if (isTujo) {
          // 商品コードが前回分の明細.商品コードと同じ場合
          if (meiFields.shohinCd === meiFields.shohinCdBefore) {
            // 前回分の必要数を考慮した可能数チェックを行う
            // 必要数がプラスで、必要数が可能数以下でない場合エラー
            if (
              Number(meiFields.hitsuyosu) >= urisuThreshold &&
              !(
                Number(meiFields.hitsuyosu) <=
                Number(meiFields.kanosu) + Number(meiFields.hitsuyosuBefore)
              )
            ) {
              setMsg(getClientError("B020012_015"));
              return true;
            }
          }
          // 商品コードが前回分の明細.商品コードと同じではない場合
          else {
            // 必要数がプラスで、必要数が可能数以下でない場合エラー
            if (
              Number(meiFields.hitsuyosu) >= urisuThreshold &&
              !(Number(meiFields.hitsuyosu) <= Number(meiFields.kanosu))
            ) {
              setMsg(getClientError("B020012_015"));
              return true;
            }
          }
          // 必要数がマイナスで、倉庫が返品倉庫でない場合エラー
          if (
            Number(meiFields.hitsuyosu) < urisuThreshold &&
            Number(meiFields.sokoshubetsuKbn) !== sokoshubetsuKbn.henpinSoko
          ) {
            setMsg(getClientError("B020012_014"));
            return true;
          }
        }

        // 内訳区分が返品(10~15)
        if (isHenpin) {
          // 売上数がプラスでない場合エラー表示し、処理を中止する。
          // マイナスの場合エラー
          if (Number(fields.urisu) < urisuThreshold) {
            setMsg(getClientError("B020012_016"));
            return true;
          }
        }
      }
    }

    // ☆セット商品区分チェック
    // セット商品の場合
    if (Number(meiFields.setshohinKbn) === setshohinKbn.set) {
      //  エラー
      setMsg(getClientError("B020012_017"));
      return true;
    }

    // WH単価の商品の場合
    if (meiFields.tankaKbn === tankaKbn.wh) {
      // 外寸が入っていない場合
      if (!meiFields.sotosunW) {
        setMsg(getClientError("B020012_019"));
        return true;
      }
      if (!meiFields.sotosunH) {
        setMsg(getClientError("B020010_019"));
        return true;
      }
      // 外寸が0以下の場合
      if (Number(meiFields.sotosunW) < whMin) {
        setMsg(getClientError("B020012_003"));
        return true;
      }
      if (Number(meiFields.sotosunH) < whMin) {
        setMsg(getClientError("B020012_004"));
        return true;
      }
    }

    return false;
  };

  // 明細のデータマッピング
  const handleDataMapping = (urikoseigyoNo: number): Data => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();
    const data: Data = {
      uridenpyoNo: meiFields.uridenpyoNo,
      urigyoNo: meiFields.urigyoNo,
      urikoseigyoNo: urikoseigyoNo,
      juchudenpyoNo: meiFields.juchudenpyoNo,
      juchugyoNo: meiFields.juchugyoNo,
      juchukoseigyoNo: meiFields.juchukoseigyoNo,
      shohinCd: meiFields.shohinCd,
      shohinCdBefore: meiFields.shohinCdBefore,
      janCd: meiFields.janCd,
      shohinNm: meiFields.shohinNm,
      aiteCd: meiFields.aiteCd,
      sokoCd: meiFields.sokoCd,
      sokoNm: meiFields.sokoNm,
      sokoshubetsuKbn: meiFields.sokoshubetsuKbn,
      vol: meiFields.vol,
      sotosunW: meiFields.sotosunW,
      sotosunH: meiFields.sotosunH,
      uchisunW: meiFields.uchisunW,
      uchisunH: meiFields.uchisunH,
      koseisu: meiFields.koseisu,
      hitsuyosu: meiFields.hitsuyosu,
      hitsuyosuBefore: meiFields.hitsuyosuBefore,
      kanosu: meiFields.kanosu,
      // 手入力上代区分の設定(一致する場合「0：変更なし」、一致する場合「1：変更あり」)
      tenyuryokujodaiKbn: isTenyuryokujodaiKbn()
        ? tenyuryokujodaiKbn.none
        : tenyuryokujodaiKbn.exists,
      // 手入力売上区分の設定(一致する場合「0：変更なし」、一致する場合「1：変更あり」)
      tenyuryokuuriKbn: isTenyuryokuuriKbn()
        ? tenyuryokuuriKbn.none
        : tenyuryokuuriKbn.exists,
      basejodaitanka: meiFields.basejodaitanka,
      baseuritanka: meiFields.baseuritanka,
      jodaitanka: meiFields.jodaitanka,
      uritanka: meiFields.uritanka,
      kakeritsu: meiFields.kakeritsu,
      uriKin: meiFields.uriKin,
      meisaikoseiBikoCd: meiFields.meisaikoseiBikoCd,
      meisaikoseiBiko: meiFields.meisaikoseiBiko,
      kazeiKbn: meiFields.kazeiKbn,
      shohinshubetsuKbn: meiFields.shohinshubetsuKbn,
      tankaKbn: meiFields.tankaKbn,
      shokuchiKbn: meiFields.shokuchiKbn,
      whtankaCd: meiFields.whtankaCd,
      setshohinKbn: meiFields.setshohinKbn,
      zaikokanriKbn: meiFields.zaikokanriKbn,
      crtDate: meiFields.crtDate,
      crtshainCd: meiFields.crtshainCd,
    };

    return data;
  };

  // 明細削除
  const handleClickDeleteMeiButton = () => {
    // 選択行の取得
    if (typeof rowData?.urikoseigyoNo === "undefined") return;
    const urikoseigyoNo: number = Number(rowData.urikoseigyoNo);
    // 明細の連番の振り直し、対象の行を削除
    const newRows = mapIds(
      rows.filter(function (source: Data) {
        return Number(source.urikoseigyoNo) !== urikoseigyoNo;
      }),
      "urikoseigyoNo"
    );

    setRows(newRows);

    // 明細クリア
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });

    // 明細入力部を新規登録に変更する
    meiMethods.setValue("meiTab", true);
    reRendering();
  };

  //合計金額算出
  const handleGokeiCalculating = () => {
    // 明細が設定されていない場合
    if (rows.length === 0) {
      // 合計金額の初期化のみ行う
      methods.setValue("setjodaitanka", "");
      methods.setValue("seturitanka", "");
      return;
    }

    // 上代単価合計(上代 × 構成数)
    const jodaitankaGokei: string = rows
      .reduce((acc: Big, row: Data): Big => {
        return acc.plus(
          new Big(row.jodaitanka ? row.jodaitanka : "0").times(
            new Big(row.koseisu!)
          )
        );
      }, new Big("0"))
      .toString();
    // 売上単価合計(下代 × 構成数)
    const uritankaGokei: string = rows
      .reduce((acc: Big, row: Data): Big => {
        return acc.plus(
          new Big(row.uritanka ? row.uritanka : "0").times(
            new Big(row.koseisu!)
          )
        );
      }, new Big("0"))
      .toString();

    // セット上代単価
    methods.setValue("setjodaitanka", jodaitankaGokei);
    // セット下代単価
    methods.setValue("seturitanka", uritankaGokei);
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (data: Data) => {
    // データを保存
    setRowData(data);
    if (typeof data.urikoseigyoNo !== "undefined") {
      // 明細入力部を編集に変更する
      meiMethods.setValue("meiTab", false);
      // 明細入力部に値を設定する
      meiMethods.setValue("uridenpyoNo", data.uridenpyoNo);
      meiMethods.setValue("urigyoNo", data.urigyoNo);
      meiMethods.setValue("urikoseigyoNo", data.urikoseigyoNo);
      meiMethods.setValue("juchudenpyoNo", data.juchudenpyoNo);
      meiMethods.setValue("juchugyoNo", data.juchugyoNo);
      meiMethods.setValue("juchukoseigyoNo", data.juchukoseigyoNo);
      meiMethods.setValue("shohinCd", data.shohinCd);
      meiMethods.setValue("shohinCdBefore", data.shohinCdBefore);
      meiMethods.setValue("janCd", data.janCd);
      meiMethods.setValue("sokoCd", data.sokoCd);
      meiMethods.setValue("sokoNm", data.sokoNm);
      meiMethods.setValue("sokoshubetsuKbn", data.sokoshubetsuKbn);
      meiMethods.setValue("shohinNm", data.shohinNm);
      meiMethods.setValue("aiteCd", data.aiteCd);
      meiMethods.setValue("sotosunW", data.sotosunW);
      meiMethods.setValue("sotosunH", data.sotosunH);
      meiMethods.setValue("uchisunW", data.uchisunW);
      meiMethods.setValue("uchisunH", data.uchisunH);
      meiMethods.setValue("hitsuyosu", data.hitsuyosu);
      meiMethods.setValue("hitsuyosuBefore", data.hitsuyosuBefore);
      meiMethods.setValue("koseisu", data.koseisu);
      meiMethods.setValue("vol", data.vol);
      meiMethods.setValue("kanosu", data.kanosu);
      meiMethods.setValue("jodaitanka", data.jodaitanka);
      meiMethods.setValue("uritanka", data.uritanka);
      meiMethods.setValue("kakeritsu", data.kakeritsu);
      meiMethods.setValue("uriKin", data.uriKin);
      meiMethods.setValue("meisaikoseiBikoCd", data.meisaikoseiBikoCd);
      meiMethods.setValue("meisaikoseiBikoBefore", data?.meisaikoseiBikoCd);
      meiMethods.setValue("meisaikoseiBiko", data.meisaikoseiBiko);
      meiMethods.setValue("kazeiKbn", data.kazeiKbn);
      meiMethods.setValue("tenyuryokujodaiKbn", data.tenyuryokujodaiKbn);
      meiMethods.setValue("tenyuryokuuriKbn", data.tenyuryokuuriKbn);
      meiMethods.setValue("basejodaitanka", data.basejodaitanka);
      meiMethods.setValue("baseuritanka", data.baseuritanka);
      meiMethods.setValue("shohinshubetsuKbn", data.shohinshubetsuKbn);
      meiMethods.setValue("tankaKbn", data.tankaKbn);
      meiMethods.setValue("shokuchiKbn", data.shokuchiKbn);
      meiMethods.setValue("whtankaCd", data.whtankaCd);
      meiMethods.setValue("zaikokanriKbn", data.zaikokanriKbn);
      meiMethods.setValue("crtDate", data.crtDate);
      meiMethods.setValue("crtshainCd", data.crtshainCd);
      focus(4);
      reRendering();
    }
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="セット構成品入力"
          gridTemplateColumns="6rem 20rem 8rem 8rem 8rem 4rem 1rem 4rem"
        >
          {!isReference && (
            <>
              <SNormalButton
                label={labels.buttons.create}
                gridColumn="8"
                onClick={handleClickCreateButton}
                {...register(4)}
              />
            </>
          )}
          <SLabel gridColumn={1}>商品コード</SLabel>
          <SNumberField name="setshohinCd" code size={10} disabled />
          <SLabel gridColumn="4">一括掛率</SLabel>
          <SNumberField
            name="ikkatsukakeritsu"
            size={3}
            {...register(2)}
            disabled={isReference}
          />
          <SNormalButton
            label={labels.buttons.calculate}
            {...register(3)}
            onClick={handleClickCalculateButton}
            disabled={isReference}
          />
          <SLabel gridColumn="1">商品名</SLabel>
          <STextField name="setshohinNm" size={40} disabled />
          <SLabel required gridColumn="1">
            売上数
          </SLabel>
          <SNumberField
            label="売上数"
            name="urisu"
            required
            size={6}
            {...register(1)}
            onBlur={() => handleChangeUrisu()}
            disabled={isReference}
          />
          <SLabel gridColumn="4">セット上代単価</SLabel>
          <SLabel>セット下代単価</SLabel>
          <SNumberField
            name="setjodaitanka"
            size={9}
            align="right"
            disabled
            gridColumn="4"
          />
          <SNumberField
            name="seturitanka"
            size={9}
            align="right"
            disabled
            gridColumn="5"
          />
        </SFrame>
      </FormProvider>
      <SFrame>
        <STable
          keyName="urikoseigyoNo"
          data={rows}
          columns={columns}
          totalCount={rowCount}
          tableRef={tableRef}
          width={1000}
          pageSize={20}
          handleDoubleClick={
            isReference ? undefined : handleDoubleClickTableRow
          }
          rowSelectable={meiMethods.watch("meiTab")}
        />
      </SFrame>
      {isReference ? (
        <></>
      ) : (
        <FormProvider {...meiMethods}>
          <SFrame gridTemplateColumns="10rem 5rem 6rem 8rem 3rem 1rem 3rem 8rem 6rem 6rem 6rem">
            {!isReference && (
              <SEntryTab
                name="meiTab"
                handleOk={() => {
                  handleChangeMeiTab();
                }}
                gridColumn="span 3"
              />
            )}
            <SLabel required gridColumn="1">
              商品コード
            </SLabel>
            <SLabel required gridColumn="span 2">
              倉庫
            </SLabel>
            <SLabel>相手コード</SLabel>
            <SLabel gridColumn="span 3">WH(外)</SLabel>
            <SLabel>必要数</SLabel>
            <SLabel>可能数</SLabel>
            <SLabel>上代</SLabel>
            <SLabel required>掛率</SLabel>
            <SNumberField
              label="商品コード"
              name="shohinCd"
              required
              code
              size={10}
              {...register(5)}
              onBlur={handleChangeShohinCd}
              dialog={<B000200 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("shohinCd", data.shohinCd);
                meiMethods.setValue("janCd", data.janCd);
                meiMethods.setValue("shohinNm", data.shohinNm);
                (async () => {
                  await B020012Shohin(methods, meiMethods, navigate, setMsg);
                  reRendering();
                })();
              }}
              gridColumn="1"
            />
            {/* 倉庫コードは、条件によって必須ではなくなるためrequiredを設定しない */}
            <STextField
              label="倉庫コード"
              name="sokoCd"
              code
              size={3}
              {...register(6)}
              onBlur={handleChangeSokoCd}
              dialog={<B000190 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("sokoCd", data?.sokoCd);
                meiMethods.setValue("sokoNm", data?.sokoNm);
                meiMethods.setValue("sokoshubetsuKbn", data?.sokoshubetsuKbn);
                (async () => {
                  await B020010Kanosu(methods, meiMethods, navigate, setMsg);
                  reRendering();
                })();
              }}
            />
            <STextField name="sokoNm" size={40} disabled />
            <STextField name="aiteCd" code size={10} {...register(8)} />
            <SNumberField
              name="sotosunW"
              size={4}
              {...register(9)}
              onBlur={handleChangeWhTanka}
            />
            <SText>✕</SText>
            <SNumberField
              name="sotosunH"
              size={4}
              {...register(10)}
              onBlur={handleChangeWhTanka}
            />
            <SNumberField name="hitsuyosu" size={6} disabled />
            <SNumberField name="kanosu" size={6} disabled />
            <SNumberField
              name="jodaitanka"
              size={9}
              {...register(14)}
              onBlur={handleCalcUritankaUriKin}
            />
            <SNumberField
              label="掛率"
              name="kakeritsu"
              required
              size={6}
              {...register(16)}
              onBlur={handleCalcUritankaUriKin}
            />
            <SLabel gridColumn="1">JANコード</SLabel>
            <SLabel gridColumn="span 3">商品名</SLabel>
            <SLabel gridColumn="span 3">WH(内)</SLabel>
            <SLabel required>構成数</SLabel>
            <SLabel>VOL</SLabel>
            <SLabel required>下代</SLabel>
            <SLabel required>金額</SLabel>
            <SNumberField name="janCd" code size={13} disabled gridColumn="1" />
            <STextField
              name="shohinNm"
              size={40}
              {...register(7)}
              disabled={!isShohinShokuchiKbn()}
              gridColumn="span 3"
            />
            <SNumberField name="uchisunW" size={4} {...register(11)} />
            <SText>✕</SText>
            <SNumberField name="uchisunH" size={4} {...register(12)} />
            {/* 受注生産品ORセット構成品の場合、在庫照会helpを非表示にする */}
            {isMeiJuchuSeisanhin() || isSetshohinKbn() ? (
              <SNumberField
                name="koseisu"
                required
                label="構成数"
                size={6}
                {...register(13)}
                onBlur={handleChangeKoseisu}
              />
            ) : (
              <SNumberField
                name="koseisu"
                required
                label="構成数"
                size={6}
                {...register(13)}
                onBlur={handleChangeKoseisu}
                dialog={<B000220 shohinCd={meiMethods.watch("shohinCd")} />}
                handleSubmit={(data: any) => {
                  meiMethods.setValue("shohinCd", data.shohinCd);
                  meiMethods.setValue("janCd", data.janCd);
                  meiMethods.setValue("shohinNm", data.shohinNm);
                  meiMethods.setValue("sokoCd", data.sokoCd);
                  meiMethods.setValue("sokoNm", data.sokoNm);
                  meiMethods.setValue("kanosu", data.zaikosu);
                  meiMethods.setValue("sokoshubetsuKbn", data.sokoshubetsuKbn);
                  // 商品関連項目設定
                  (async () => {
                    await B020012ShohinZaiko(
                      methods,
                      meiMethods,
                      navigate,
                      setMsg
                    );
                    reRendering();
                  })();
                }}
              />
            )}
            <SNumberField name="vol" code size={10} disabled />
            <SNumberField
              label="下代"
              name="uritanka"
              required
              size={9}
              {...register(15)}
              onBlur={handleCalcUriKinFromUritanka}
            />
            <SNumberField
              label="金額"
              name="uriKin"
              required
              size={9}
              {...register(17)}
              disabled={isKingakuDisabled()}
            />
            <SText gridColumn="1"></SText>
            <SText gridColumn="span 7"></SText>
            <SLabel gridColumn="span 3">構成明細備考</SLabel>
            <SNumberField
              name="meisaikoseiBikoCd"
              code
              size={3}
              {...register(18)}
              onBlur={() =>
                B000111meisaikoseiBiko(meiMethods, navigate, setMsg)
              }
              dialog={<B000111 meishoKbn="7" />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("meisaikoseiBikoCd", data?.meishoCd);
                meiMethods.setValue("meisaikoseiBikoBefore", data?.meishoCd);
                meiMethods.setValue("meisaikoseiBiko", data?.meishoNm1);
              }}
              gridColumn="9"
            />
            <STextField
              name="meisaikoseiBiko"
              size={30}
              {...register(19)}
              gridColumn="span 2"
            />
            {!meiMethods.watch("meiTab") && (
              <SCancelButton
                label={labels.buttons.deleteDetail}
                gridRow="8"
                gridColumn="1"
                onClick={handleClickDeleteMeiButton}
              />
            )}
            {meiMethods.watch("meiTab") ? (
              <SNormalButton
                label={labels.buttons.createDetail}
                {...register(20)}
                gridRow="8"
                gridColumn="11"
                align="right"
                onClick={handleClickCreateMeiButton}
              />
            ) : (
              <SNormalButton
                label={labels.buttons.updateDetail}
                {...register(20)}
                gridRow="8"
                gridColumn="11"
                align="right"
                onClick={handleClickUpdateMeiButton}
              />
            )}
          </SFrame>
        </FormProvider>
      )}
    </>
  );
};
